module.exports = __webpack_public_path__ + "static/media/p18.82fe84a3.png";